module.exports = __webpack_public_path__ + "c0fe0a3561c291926e7e2fc5c985cb25.svg";